import api from '../../api'
const recurrenceAPI = api.create('recurrence')

const get = async ({ postalCode }) => {
  return await recurrenceAPI.get(`/cep/${postalCode}`)
}

export default { get }
